import imagesloaded from 'imagesloaded'

export function onImagesLoaded(container, options = {}) {
  return new Promise(resolve => {
    if (!container) return resolve()
    imagesloaded(container, options, resolve)
  })
}
